export default __webpack_public_path__ + "media/images/playbutton-6a97f83b297c9261fe3e62534cdfcb6e.svg";